import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { ReviewedFilterValues } from '../FilterBar.constants'
import { FilterDropdown } from './FilterDropdown'

export const ReviewedFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    const filterValues = [
      {
        value: ReviewedFilterValues.REVIEWED,
        label: 'Reviewed',
      },
      {
        value: ReviewedFilterValues.NOT_REVIEWED,
        label: 'Not Reviewed',
      },
    ]

    return (
      <FilterDropdown
        filterParam={FilterParam.REVIEWED}
        filterName={FilterName.REVIEWED}
        filterValues={filterValues}
        isNested={isNested}
      />
    )
  },
)
